import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { scopedCollection } from '../server/scoped-collection.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { mongo } from '../server/mongo.js';

// create indices
export async function ensureUserStammdatenIndexes(): Promise<void> {
  const stammdatenCollection = mongo().collection('user-stammdaten');
  await stammdatenCollection.createIndex({ userID: 1, institutionID: 1 }, { unique: true });
}

@Entity()
export class UserStammdaten extends MongoEntity {
  static override _class = 'UserStammdaten';
  static override _collectionName = 'user-stammdaten';

  static get allFields() {
    return selectionSet(() => this, 3);
  }

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @validate(nonOptional())
  @Field(type => ID)
  userID!: string;

  @validate(nonOptional())
  @Field(type => String)
  institutionID: Maybe<string>;

  getTranslationNamespace(): Maybe<string> {
    return null;
  }

  static override async beforeCreate(entity: UserStammdaten): Promise<void> {
    super.beforeCreate(entity);

    const existing = await (
      await scopedCollection<UserStammdaten>(UserStammdaten._class)
    ).findOne({
      userID: entity.userID,
      institutionID: entity.institutionID,
    });
    if (existing) {
      throw new Error('user stammdaten needs to be unique across ');
    }
  }

  static getSelector(userID: string, institutionID: Maybe<string>) {
    return institutionID ? { userID, institutionID } : { userID, institutionID: null };
  }
}
